import {QueryClient} from '@tanstack/react-query'

// Shared so that logout can clear cached server data
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 100, // Debounce to prevent infinite refetching
    },
  },
})
